// Unpublished Work © 2020 Deere & Company

import t from 'tcomb';

export const Locale = t.enums({
    'en-AU': 'en-AU',
    'en-CA': 'en-CA',
    'en-NZ': 'en-NZ',
    'en-US': 'en-US',
    'fr-CA': 'fr-CA'
}, 'Locale');
